// Признак привязки комплекта к логину: платный / бесплатный / тестовый.
// Значения совпадают с enum AccessKind на бэкенде (tinyint) и с access_kind в контроль-панели.
export const ACCESS_KIND_PAID = 0;
export const ACCESS_KIND_FREE = 1;
export const ACCESS_KIND_TEST = 2;

export const ACCESS_KIND_ITEMS = [
  { text: "Платный", value: ACCESS_KIND_PAID },
  { text: "Бесплатный", value: ACCESS_KIND_FREE },
  { text: "Тестовый", value: ACCESS_KIND_TEST },
];

export function accessKindText(value) {
  const item = ACCESS_KIND_ITEMS.find((x) => x.value === Number(value));
  return item ? item.text : "Платный";
}
